import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'html-editor',
    templateUrl: './html-editor.component.html',
    styleUrls: ['./html-editor.component.scss'],
    standalone: false
})
export class HtmlEditorComponent implements OnInit {

  public htmlContent;

  constructor(
    public dialogRef: MatDialogRef<HtmlEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    this.htmlContent = this.data;
  }

  save() {
    this.dialogRef.close(this.htmlContent);
  }

  cancel() {
    this.dialogRef.close();
  }

}
